import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { EditColumnsIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { FilterBar } from 'foundations-components/transitional/components/FilterBar';
import { useReportingFiltersProvider } from '../../providers/ReportingFiltersProvider';
import CustomColumnSwitcherModal from './CustomColumnSwitcherModal';
import useUsageTrackerProps from '../../hooks/useUsageTrackerProps';
import { DETAILS_INTERACTION } from '../../constants/trackerEvents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function capitalize(str = '') {
  return str[0].toUpperCase() + str.slice(1);
}
const SelectedSourcesBreadcrumbs = ({
  d1,
  source,
  handleSourceDrilldown
}) => {
  if (!source) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Breadcrumbs, {
    flush: true,
    singleBreadcrumbIsBackLink: false,
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: () => handleSourceDrilldown({}),
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "content-management-details-lib.reporting.sourcesTableFilterBar.allSources"
      })
    }, "all"), d1 ? [/*#__PURE__*/_jsx(Link, {
      onClick: () => handleSourceDrilldown({
        key: source
      }),
      children: capitalize(source)
    }, "source"), /*#__PURE__*/_jsx("span", {
      children: d1
    }, "d1")] : /*#__PURE__*/_jsxs("span", {
      children: [" ", capitalize(source)]
    }, "source")]
  });
};
const SourcesTableFilterBar = () => {
  const {
    d1,
    source,
    handleSourceDrilldown
  } = useReportingFiltersProvider();
  const [isColumnSwitcherOpen, setIsColumnSwitcherOpen] = useState(false);
  const {
    tracker
  } = useUsageTrackerProps();
  return /*#__PURE__*/_jsx(FilterBar, {
    startSlot: /*#__PURE__*/_jsx(SelectedSourcesBreadcrumbs, {
      d1: d1,
      source: source,
      handleSourceDrilldown: handleSourceDrilldown
    }),
    endSlot: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Button, {
        use: "link",
        onClick: () => {
          setIsColumnSwitcherOpen(true);
          tracker.track(DETAILS_INTERACTION, {
            action: 'clicked-open-source-table-columns-switcher'
          });
        },
        children: [/*#__PURE__*/_jsx(EditColumnsIcon, {
          size: "300"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-details-lib.reporting.sourcesTableFilterBar.columnSwitcher.button"
        })]
      }), /*#__PURE__*/_jsx(CustomColumnSwitcherModal, {
        closeModal: () => setIsColumnSwitcherOpen(false),
        isColumnSwitcherOpen: isColumnSwitcherOpen
      })]
    })
  });
};
export default SourcesTableFilterBar;